import { useMerchant } from "./MerchantContext";

export const PermissionsGuard = ({ children, permission }) => {
  const { hasPermission } = useMerchant();

  return hasPermission(permission) ? children : <div className="">
    <h1>Forbidden</h1>
    <h1>You do not have the required permissions to access this area. Please contact your system administrator.</h1>


  </div>;
};
